import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 87.974 87.969',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      className="icon"
      d="M80.823.284,25.844,16.52a5.5,5.5,0,0,0-3.851,5.242V66.679a23.884,23.884,0,0,0-5.5-.674C7.388,66.005,0,70.93,0,77S7.388,88,16.5,88s16.5-4.924,16.5-11V36.85L76.977,23.963V55.684a23.781,23.781,0,0,0-5.5-.675c-9.107,0-16.5,4.924-16.5,11s7.388,11,16.5,11,16.5-4.923,16.5-11V5.523A5.5,5.5,0,0,0,80.823.284Z"
      transform="translate(0 -0.029)"
      fill={fill}
    />
  </svg>
);

export default SVG;
